const parseRelatedProducts = (products) => {
  if (!products
    || !products.size) return null;

  return products
    .valueSeq().toArray()
    .map(prod => {
    return {
      value: prod.get('value'),
      label: prod.get('label'),
    }
  });
};

export default parseRelatedProducts;



// WEBPACK FOOTER //
// ./src/helpers/parseRelatedProducts.js